import { render } from "./WohnungStep4.vue?vue&type=template&id=8cff9e7e&scoped=true"
import script from "./WohnungStep4.vue?vue&type=script&lang=js"
export * from "./WohnungStep4.vue?vue&type=script&lang=js"

import "./WohnungStep4.vue?vue&type=style&index=0&id=8cff9e7e&scoped=true&lang=css"

import exportComponent from "/Users/a98ca8a/projects/immo-calculator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cff9e7e"]])

export default __exports__